var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "open menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,14H7a2,2,0,0,1,0-4H41A2,2,0,0,1,41,14Z",
    fill: "#170123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41,26H7a2,2,0,0,1,0-4H41A2,2,0,0,1,41,26Z",
    fill: "#170123"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41,38H7a2,2,0,0,1,0-4H41A2,2,0,0,1,41,38Z",
    fill: "#170123"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHamburgerMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hamburger-menu.d8781c5e34bd7887087753f99b0bc00a.svg";